import { Dispatch } from 'redux';
import { ApiApplication } from 'src/http';
import { notificationsActions } from 'src/slices/notifications-slice';

const { setNotificationsListFailure, setNotificationsListRequest, setNotificationsListSuccess } =
  notificationsActions;

export const getNotifications = (params?: Record<string, any>) => async (dispatch: Dispatch) => {
  dispatch(setNotificationsListRequest());
  try {
    const data = await ApiApplication.fetchNotifications(params);
    dispatch(setNotificationsListSuccess(data));
  } catch (error) {
    dispatch(setNotificationsListFailure(error));
  }
};
